import classNames from "classnames"
import React, { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody } from "reactstrap"
import StackedColumnChart from "./StackedColumnChart"
import { useTranslation } from "react-i18next"

const oneMonthCategories = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
]

const PurchaseRate = () => {
  const { t } = useTranslation()

  const {
    sixMonthCategory,
    yearCategories,
    yearData,
    oneMonthData,
    sixMonthData,
  } = useMemo(() => {
    const sixMonthCategory = [
      t("customers_jan"),
      t("customers_feb"),
      t("customers_mar"),
      t("customers_apr"),
      t("customers_may"),
      t("customers_jun"),
    ]

    const yearCategories = [
      t("customers_jan"),
      t("customers_feb"),
      t("customers_mar"),
      t("customers_apr"),
      t("customers_may"),
      t("customers_jun"),
      t("customers_jul"),
      t("customers_aug"),
      t("customers_sep"),
      t("customers_oct"),
      t("customers_nov"),
      t("customers_dec"),
    ]

    const yearData = [
      {
        name: t("customers_lastYear"),
        data: [44, 55, 41, 67, 22, 43, 36, 52, 24, 18, 36, 48],
      },
      {
        name: t("customers_currentYear"),
        data: [13, 23, 20, 8, 13, 27, 18, 22, 10, 16, 24, 22],
      },
    ]

    const sixMonthData = [
      {
        name: t("customers_previous6Months"),
        data: [34, 55, 21, 77, 32, 63],
      },
      {
        name: t("customers_last6Months"),
        data: [10, 63, 40, 80, 52, 41],
      },
    ]

    const oneMonthData = [
      {
        name: t("customers_lastMonth"),
        data: [
          11, 11, 21, 32, 33, 34, 88, 3, 9, 13, 10, 11, 12, 22, 35, 24, 24, 24,
          24, 2, 44, 4, 1, 4, 64, 76, 43, 54, 1, 33, 11,
        ],
      },
      {
        name: t("customers_currentMonth"),
        data: [
          13, 23, 20, 8, 13, 27, 18, 22, 10, 16, 24, 22, 12, 11, 10, 9, 8, 7, 6,
          5, 4, 3, 2, 1, 2, 3, 4, 5, 6, 7, 8,
        ],
      },
    ]

    return {
      sixMonthCategory,
      yearCategories,
      yearData,
      sixMonthData,
      oneMonthData,
    }
  }, [t])

  const [periodData, setPeriodData] =
    useState<{ name: string; data: number[] }[]>(oneMonthData)
  const [category, setCategory] = useState(oneMonthCategories)
  const [periodType, setPeriodType] = useState("oneMonthData")

  const onChangeChartPeriod = (period: string) => {
    setPeriodType(period)
    if (period === "oneMonthData") {
      setPeriodData(oneMonthData)
      setCategory(oneMonthCategories)
    } else if (period === "sixMonthData") {
      setPeriodData(sixMonthData)
      setCategory(sixMonthCategory)
    } else {
      setPeriodData(yearData)
      setCategory(yearCategories)
    }
  }

  return (
    <Card className="shadow-md mt-3 h-100">
      <CardBody>
        <div className="d-sm-flex flex-wrap">
          <h4 className="card-title mb-4">{t("customers_purchaseRate")}</h4>
          <div className="ms-auto">
            <ul className="nav nav-pills px-2">
              <li className="nav-item">
                <Link
                  to="#"
                  className={classNames(
                    { active: periodType === "oneMonthData" },
                    "nav-link"
                  )}
                  onClick={() => {
                    onChangeChartPeriod("oneMonthData")
                  }}
                  id="one_month"
                >
                  {t("customers_perMonth")}
                </Link>{" "}
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={classNames(
                    { active: periodType === "sixMonthData" },
                    "nav-link"
                  )}
                  onClick={() => {
                    onChangeChartPeriod("sixMonthData")
                  }}
                  id="one_month"
                >
                  {t("customers_sixMonths")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={classNames(
                    { active: periodType === "yearData" },
                    "nav-link"
                  )}
                  onClick={() => {
                    onChangeChartPeriod("yearData")
                  }}
                  id="one_month"
                >
                  {t("customers_oneYear")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="clearfix"></div> */}
        <StackedColumnChart periodData={periodData} category={category} />
      </CardBody>
    </Card>
  )
}

export default PurchaseRate
